import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../../common/Button";

const PassButton = ( props ) => {

  const { t } = useTranslation();

  return <div className="ask_area"><Button onClick={props.onPass} className="ask">{ t( 'LC_02_06.msg006' ) }</Button></div>;

};

export default PassButton;
